import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "../styles/noticiaDetalle.css";
import api from "../services/api";

const formatFecha = (isoDate) =>
  new Date(isoDate).toLocaleDateString("es-BO", {
    year: "numeric",
    month: "long",
  });

const CursoDetalle = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [curso, setCurso] = useState(null);

  useEffect(() => {
    const fetchCurso = async () => {
      try {
        const res = await api.get(`/cursos/${id}/`);
        setCurso({
          titulo: res.data.titulo,
          categoria: res.data.categoria,
          descripcion: res.data.descripcion,
          portada: res.data.portada,
          fecha: formatFecha(res.data.updated_at),
        });
      } catch (err) {
        console.error("Error cargando curso", err);
      }
    };

    fetchCurso();
  }, [id]);

  if (!curso) return null;

  return (
    <section className="noticia-detalle-container">
      <button className="volver-btn" onClick={() => navigate(-1)}>
        ← Volver
      </button>
      <h1 className="titulo">{curso.titulo}</h1>
      <div className="meta">
        <span className="categoria">{curso.categoria}</span>
        <span className="fecha">{curso.fecha}</span>
      </div>
      <img
        src={curso.portada}
        alt={curso.titulo}
        className="imagen-principal"
      />
      <p className="contenido">{curso.descripcion}</p>
    </section>
  );
};

export default CursoDetalle;
